module.exports = __webpack_public_path__ + "img/image36.8a120812.webp";